import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const amazonMusic: MusicService = {
  id: 'amazon-music',
  name: 'Amazon Music',
  shortName: 'Amazon Music',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: true,
  isAlbumTransferSupported: false,
  color: {
    primary: '#0077C1',
    label: '#0077C1',
    background: '#687783',
  },
  importerID: ImporterID.AmazonMusic,
  musicAPIID: MusicAPIIntegrationID.AmazonMusic,
  linkType: 'amazonmusic',
  limits: {
    tracksPerPlaylist: 2500,
  },
  assets: {
    logo: { light: 'amazon-light.svg', dark: 'amazon-dark.svg' },
    logoPadding: { light: 'amazon-light-padding.svg', dark: 'amazon-dark-padding.svg' },
    logoColor: { light: 'amazon-color-light.svg', dark: 'amazon-color-dark.svg' },
    logoColorPadding: {
      light: 'amazon-color-light-padding.svg',
      dark: 'amazon-color-dark-padding.svg',
    },
    logoOnBackground: 'amazon-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.amazonMusicWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: false,
    maxLimit: 100,
  },
};
